import React from 'react'
import Details from './Details'
import Questions from './Questions'
import Narrative from './Narrative'
import Finish from './Finish'
import { useSelector } from 'react-redux'
import { getSpecialReportsSelector } from '../selectors'
import { STEP_IDS } from '../constants/specialReportsStepper.constants'
import { IonContent } from '@ionic/react'
import ReportType from './ReportType'
import './SpecialReports.content.css'

const SpecialReportsContent: React.FC = () => {
  const specialReportsState = useSelector(getSpecialReportsSelector)
  const { __currentStep, __currentSubStep } = specialReportsState

  const renderStepContent = () => {
    switch (__currentStep) {
      case STEP_IDS.DETAILS:
        // Sub-step 1.1: Details, Sub-step 1.2: ReportType
        if (__currentSubStep === 1) {
          return <Details />
        } else {
          return <ReportType />
        }
      case STEP_IDS.QUESTIONS:
        return <Questions />
      case STEP_IDS.NARRATIVE:
        return <Narrative />
      case STEP_IDS.FINISH:
        return <Finish />
      default:
        return null
    }
  }

  return (
    <IonContent className='ion-no-padding' color=''>
      {renderStepContent()}
    </IonContent>
  )
}

export default SpecialReportsContent
